import { Component } from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { Store } from '@ngrx/store';
import * as fromFermenter from 'app/state/fermenter';
import { IFermenterVM } from 'app/models/fermenter';

@Component({
  selector: 'app-fermenter-picker',
  templateUrl: './fermenter.component.html',
  styleUrls: ['./fermenter.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class FermenterPickerComponent {

  items = this.store.selectSignal(fromFermenter.selectFermentersNotInSelectedTower);

  constructor(
    private store: Store,
    private modalController: ModalController
  ) { }

  async closeModal() {
    await this.modalController.dismiss();
  }

  async selectFermenter(fermenter: IFermenterVM) {
    await this.modalController.dismiss(fermenter);
  }
}
